import { render, staticRenderFns } from "./crop_pests_diseases.vue?vue&type=template&id=6afb1fc0&"
import script from "./crop_pests_diseases.vue?vue&type=script&lang=js&"
export * from "./crop_pests_diseases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports